module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/DV8JaH/media/FC-9781035844302.jpg?1718732568029",
      "alt": "This image is the cover for the book Lionheart: A Beacon of Hope"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Lionheart: A Beacon of Hope\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("This story concerns a salmon named Sami who searches far and wide for a home and, in the process, discovers himself. Life is a constant struggle to endure and overcome and there are few that have it more dangerous and difficult than the salmon. We admire their determination, tenacity, and sacrifice to achieve their goal. Sami had made the seemingly impossible become possible. Upon reaching his goal, a gateway opened, and a great silence fell, giving authentic insight, true revelation, and the experience of oneself in all things.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      James L. Wild\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("James was born in London in 1936 where he experienced the outbreak of the Second World War. In 1941, he was taken to Canada and educated there and in the US. Upon graduation he worked as a map surveyor in the Canadian arctic. The land was surveyed for map making during the winter months as it was easier to traverse and measure the distance. James learned the ways of the north by living with the Cree Indians. He walked on snowshoes and many days covered over 50 miles in -70°F weather. He camped out in a tent, cooked over a wood fire, which he started without matches, a skill he learnt from the Cree and boiled snow for water. After his northern adventures and further worldwide travelling, he established a chain of retail stores selling sheepskins and homemade goods. A few decades later, he returned to the UK and settled on a farm.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0